import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

export const calendarEventSave: TypedDocumentNode<
    Pick<GQL.IMutation, "calendarEventSave">,
    GQL.IMutationCalendarEventSaveArgs
> = gql`
    mutation calendarEventSave($input: CalendarEventInput!) {
        calendarEventSave(input: $input) {
            id
            companyId
            createdBy
            assigneeId
            title
            notes
            type
            eventDate
            contactId
            color
            createdAt
            updatedAt
        }
    }
`;

export const calendarEventDelete: TypedDocumentNode<
    Pick<GQL.IMutation, "calendarEventDelete">,
    GQL.IMutationCalendarEventDeleteArgs
> = gql`
    mutation calendarEventDelete($input: IDCompanyIDInput!) {
        calendarEventDelete(input: $input)
    }
`;

// SP3 (FIBU-22): partial-merge upsert - see CalendarItemStateInput's field
// comments in calendar.graphql; absent fields are left unchanged server-side.
export const calendarItemStateSet: TypedDocumentNode<
    Pick<GQL.IMutation, "calendarItemStateSet">,
    GQL.IMutationCalendarItemStateSetArgs
> = gql`
    mutation calendarItemStateSet($input: CalendarItemStateInput!) {
        calendarItemStateSet(input: $input) {
            companyId
            refType
            refId
            doneAt
            acknowledgedAt
            note
            color
            updatedAt
        }
    }
`;
